import { render, staticRenderFns } from "./WayList.vue?vue&type=template&id=63985bd0&scoped=true"
import script from "./WayList.vue?vue&type=script&lang=js"
export * from "./WayList.vue?vue&type=script&lang=js"
import style0 from "./WayList.vue?vue&type=style&index=0&id=63985bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63985bd0",
  null
  
)

export default component.exports